import React from 'react';

import ReactDOM from 'react-dom';

import {OrganizationUserCard} from '../OrganizationUserCard/OrganizationUserCard';
import type {OrganizationUserCardProps} from '../OrganizationUserCard/types';

import {fetchUserFactory} from './fetchUserFactory';
import type {OrganizationUserCardOptions} from './types';

const Defaults: OrganizationUserCardOptions = {
    selector: '[data-user-id]',
    cacheTTL: 60000,
    getUserId: (anchor) => anchor.dataset.userId,
    onError: (meta) => console.error('OrganizationUserCardError', meta),
};

export function setOrganizationUserCards({
    containerRef,
    selector = Defaults.selector,
    route,
    cacheTTL = Defaults.cacheTTL,
    fetchUser,
    getUserId = Defaults.getUserId,
    disabled,
    className,
    onError = Defaults.onError,
}: OrganizationUserCardOptions): void | (() => void) {
    const container = containerRef && containerRef.current;

    if (!container) {
        return;
    }

    if (!fetchUser) {
        fetchUser = fetchUserFactory({route, cacheTTL, getUserId, onError});
    }

    const onMouseOver = ({target}: MouseEvent) => {
        const anchor = target instanceof HTMLElement ? target.closest(selector) : null;

        if (
            anchor instanceof HTMLElement &&
            !(typeof disabled === 'function' ? disabled(anchor) : disabled) &&
            anchor.dataset.userCardInitialized !== 'true'
        ) {
            const cardProps: OrganizationUserCardProps = {
                anchorRef: {current: anchor},
                user: () => fetchUser!(anchor),
                initiallyOpen: true,
                className,
            };

            const cardContainer = document.createElement('div');
            document.body.appendChild(cardContainer);

            ReactDOM.render(
                React.createElement(OrganizationUserCard, cardProps),
                cardContainer,
                // карточка рендерится в попапе, который маунтится вне контейнера,
                // поэтому после рендеринга контейнер можно удалить
                () => cardContainer.remove(),
            );

            anchor.dataset.userCardInitialized = 'true';
        }
    };

    container.addEventListener('mouseover', onMouseOver);

    return () => {
        container.removeEventListener('mouseover', onMouseOver);
    };
}
